import { regexp } from 'constant/regexp';

export const useGetIsMobile = () => {
  const isMobile = regexp.mobile.test(navigator.userAgent);
  const isAndroid = regexp.android.test(navigator.userAgent);

  return { isMobile, isAndroid };
};
